// extracted by mini-css-extract-plugin
export var articles = "articles-module--articles--cae77";
export var articles_container = "articles-module--articles_container--7ef5a";
export var bar = "articles-module--bar--45e3c";